import NotificationSkeleton from './notification-skeleton'

const AllNotificationsSkeleton = () => {
  return (
    <div className="flex w-full flex-1 flex-col">
      <NotificationSkeleton />
      <NotificationSkeleton />
      <NotificationSkeleton />
      <NotificationSkeleton />
      <NotificationSkeleton />
    </div>
  )
}

export default AllNotificationsSkeleton
